import { Type } from 'class-transformer'

import { Base } from './Base'
import { Sku } from './Sku'

export class SkuPathResponse extends Base {
  @Type(() => Sku)
  sku?: Sku

  paths?: string[]
}
